import { NipFieldsService } from './../core/nip-fields.service';
import { NipService } from 'src/app/_services/nip.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, formatDate } from '@angular/common';
import { User } from 'src/app/_models';
import { ActiveTimeTracker } from 'src/app/_models/active-time-tracker';
import { Activites } from 'src/app/_models/activites';
import { Nip } from 'src/app/_models/nip';
import { Operation } from 'src/app/_models/operation';
import { PackageType } from 'src/app/_models/package_type';
import { Partner } from 'src/app/_models/partner';
import { Product } from 'src/app/_models/product';
import { ProductType } from 'src/app/_models/product_type';
import { Status } from 'src/app/_models/status';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessService } from 'src/app/_services/mess-service.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-nip-edit-improved',
  templateUrl: './nip-edit-improved.component.html',
  styleUrls: ['./nip-edit-improved.component.scss'],
  providers: [DatePipe],
})
export class NipEditImprovedComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscriptions: Subscription[] = [];
  id: number;

  updateNipForm: FormGroup;
  editTimeTrackerForm: FormGroup;
  timeTrackerId: number;

  disableSave: boolean = true;
  loading = false;
  showModal = false;

  allPackageTypes: PackageType[];

  allProductTypes: ProductType[];
  allDocuments = [];
  allPartners: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };

  products: {
    data: any[];
    pagination: any;
  } = {
    data: null,
    pagination: null,
  };

  defaultProduct;
  selectedPartner;

  allProducts: Product[];
  selectedProduct: Product;
  selectedProductOperations: Operation[];

  allStatuses: Status[];

  allTimeTrackers: ActiveTimeTracker[];

  currentUser: User;
  currentDate = formatDate(new Date(), 'dd.MM.yyyy', 'en');

  isFromAddPage: boolean = false;

  savedFormData: Nip;

  nipForEdit: Nip;

  allActivities: Activites;

  allPriority = [
    { name: 'Hitno', label: 0 },
    { name: 'Regularno', label: 1 },
    { name: 'Lager', label: 2 },
  ];

  getEditNipData: Nip;

  // Users that can edit main NIP fields
  authUsersForEdit = ['admin', 'prodavac'];
  isUserAuthForEdit: boolean;

  // Checkbox group
  readyItemsGroup: any[] = [
    { name: 'Radni nalog odštampan', value: 'printed' },
    { name: 'Dokumentacija spremna', value: 'documentation_ready' },
    { name: 'Materijal istrebovan', value: 'material_ready' },
    // { name: 'Zatvori nalog', value: 'complete' },
  ];
  selectedItemsGroup: any[];

  reportData: any[];
  constructor(
    private nipService: NipService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public fieldsService: NipFieldsService,
    private datePipe: DatePipe,
    private authService: AuthenticationService,
    private messService: MessService,
    private confirmationService: ConfirmationService
  ) {}

  /* ====================================
     *              LIFECYCLES
     ======================================= */
  ngOnInit(): void {
    this.getPartners();

    // * Get current user data
    this.currentUser = this.authService.userValue;

    // * Check is user authorized to edit main fields
    this.isUserAuthForEdit = this.authService.isAuthorized(
      this.authUsersForEdit
    );

    this.id = this.route.snapshot.params['id'];
    this.getData();

    this.editTimeTrackerForm = this.fb.group({
      start: [''],
      end: [''],
      produced_amount: '',
    });

    // * Create form
    this.updateNipForm = this.fb.group({
      batch: ['', Validators.required],
      creator_id: [this.currentUser.user.id, Validators.required],
      request_nr: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      partner_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      deadline: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      packaging_type_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      required_units: [{ value: '', disabled: this.isUserAuthForEdit }],
      planned_units: [{ value: '', disabled: this.isUserAuthForEdit }],
      status_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      note: [{ value: '', disabled: this.isUserAuthForEdit }],
      complaint: [''],

      total_estimated_time: [{ value: '', disabled: true }],
      product_id: [
        { value: '', disabled: this.isUserAuthForEdit },
        Validators.required,
      ],
      priority: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'prodavac',
          ]),
        },
      ],
      parallel_operations: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'prodavac',
          ]),
        },
      ],
      ready_items: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
      complete: [
        {
          value: '',
          disabled: this.authService.isAuthorized([
            'admin',
            'sefProizvodnje',
            'tehnolog',
          ]),
        },
      ],
      enable_add_operations: [
        {
          value: '',
          disabled: this.authService.isAuthorized(['admin', 'sefProizvodnje']),
        },
      ],
    });

    this.onGetallActivities(1);

    // * Get all data for form fields
    this.subscriptions.push(
      this.nipService.getCreateData().subscribe((getEditNipData) => {
        this.getEditNipData = getEditNipData;

        this.checkIsUserFromAddPage();
        // Package types
        this.allPackageTypes = getEditNipData.packaging_types;

        // Partners
        // this.allPartners = getEditNipData.partners;

        // Statuses
        this.allStatuses = getEditNipData.statuses;

        // * Get previous url
        // this.subscriptions.push(
        //   this.route.queryParams.subscribe((params) => {
        //     // Defaults to 0 if no query param provided.
        //     const previousUrl = params['fromPage'] || 0;
        //     const addedPartner = params['addedPartner'] || 0;
        //     this.isFromAddPage = previousUrl != 0 ? true : false;
        //     if (addedPartner !== 0) {
        //       // Proverava da li je korisnik koji dolazi sa ADD stranice dodao Partnera,
        //       // ako jeste ubacuje ID tog partnera u formu
        //       this.updateNipForm.patchValue({
        //         partner_id: this.allPartners.find(
        //           (partner) => partner.company == addedPartner
        //         ).id,
        //       });
        //     }
        //   })
        // );
      })
    );

    // this.updateNipForm.get('product_id').valueChanges.subscribe((value) => {
    //   console.log('AAAAAAAAAAAAAAAAAA', value);

    //   this.newProductSelected(value);
    // });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
     *             MAIN FEATURES
     ======================================= */

  getData() {
    this.loading = true;
    this.subscriptions.push(
      this.nipService.getOne(this.id).subscribe({
        complete() {
          // this.createFormForUpdate();
          // this.getReport();
        },
        next: (response: any) => {
          this.nipForEdit = response;
          this.allDocuments =
            this.nipForEdit?.product?.technical_documentations;

          // this.nipForEdit.time_trackers = response.time_trackers.concat(
          //   response.active_time_trackers
          // );

          this.selectedItemsGroup = response.ready_items;

          this.createFormForUpdate();
          this.getReport();

          this.getProducts();

          this.loading = false;
        },
        error: (err: any) => {},
      })
    );
  }

  onUpdateNip() {
    const nip = this.updateNipForm.getRawValue();

    let datePipe = new DatePipe('en-US');
    nip.deadline = datePipe.transform(nip.deadline, 'yyyy-MM-dd');
    nip.ready_items = this.selectedItemsGroup;
    this.subscriptions.push(
      this.nipService.updateNip(this.nipForEdit.id, nip).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešna izmena',
            detail: 'Uspešno ste izmenili NIP.',
          });
          // this.router.navigate(['./../../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.updateNipForm;
          const messService = this.messService;

          // && !errorObj.ready_items

          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl && !errorObj.ready_items) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  onDelete(e, timeTracker) {
    e.preventDefault();
    e.stopPropagation();

    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete ovu stavku?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.nipService.deleteTimeTracker(timeTracker.id).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste merenje vremena.',
              });
              this.getData();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  onExportToPDF() {
    this.loading = true;

    this.subscriptions.push(
      this.nipService.exportToPDF(this.nipForEdit.id).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
        this.loading = false;
      })
    );
  }

  onExportControlSheetToPDF() {
    this.loading = true;

    this.subscriptions.push(
      this.nipService
        .exportControlSheetToPDF(this.nipForEdit.id)
        .subscribe((pdfHref) => {
          window.open(pdfHref.href, '_blank');
          this.loading = false;
        })
    );
  }

  onExportZK() {
    this.loading = true;
    this.subscriptions.push(
      this.nipService.exportZK(this.nipForEdit.id).subscribe((pdfHref) => {
        window.open(pdfHref.href, '_blank');
        this.loading = false;
      })
    );
  }

  onExportDocument(event = null) {
    this.loading = true;
    if (event) {
      console.log(event);
      window.open(event.data.path, '_blank');
      this.loading = false;
    } else {
      const documentForDownload =
        this.nipForEdit?.product?.technical_documentations[0];

      if (documentForDownload) {
        window.open(documentForDownload.path, '_blank');
        this.loading = false;
      }
    }
  }
  getPartners(pageIndex = 1, searchTerm = ''): void {
    this.subscriptions.push(
      this.nipService.getPartners(pageIndex, 60, searchTerm).subscribe({
        next: (res: any) => {
          if (pageIndex === 1) {
            this.allPartners.data = [];
            this.allPartners.pagination = null;
          }

          this.allPartners.data = [...this.allPartners.data, ...res.data];
          this.allPartners.pagination = res?.pagination;
        },
        error: (err) => {},
      })
    );
  }

  getProducts(pageIndex = 1, searchTerm = ''): void {
    this.subscriptions.push(
      this.nipService.getProducts(pageIndex, 60, searchTerm).subscribe({
        next: (res: any) => {
          if (pageIndex === 1) {
            this.products.data = [];
            this.products.pagination = null;
          }

          this.products.data = [...this.products.data, ...res.data];
          this.products.pagination = res?.pagination;

          //* Show only products that have not been deleted or have ID same with Product from NipForEdit
          this.products.data = this.products.data.filter(
            (product) =>
              product.id == this.nipForEdit.product_id ||
              product.deleted_at == null
          );

          this.selectedProductOperations = this.nipForEdit.product.operations;
        },
        error: (err) => {},
      })
    );
  }

  /* ====================================
  *                HELPERS
  ======================================= */

  private onGetallActivities(pageIndex: number) {
    this.subscriptions.push(
      this.nipService
        .getActivites(this.id, pageIndex)
        .subscribe((responseData: Activites) => {
          this.allActivities = responseData;
        })
    );
  }

  // findSelectedPartner() {
  //   return this.allPartners.find(
  //     (partner) => partner.id == this.updateNipForm.get('partner_id').value
  //   );
  // }

  // findSelectedProduct() {
  //   return this.allProducts.find(
  //     (product) => product.id == this.updateNipForm.get('product_id').value
  //   );
  // }

  // Remove or add item when user check/uncheck checkbox
  onCheckItem(itemValue) {
    if (this.selectedItemsGroup.includes(itemValue)) {
      this.selectedItemsGroup = this.selectedItemsGroup.filter(
        (item) => item !== itemValue
      );
    } else {
      this.selectedItemsGroup.push(itemValue);
    }
  }

  // * Activites on page change
  onActivitesPageChange(event) {
    this.onGetallActivities(event.page + 1);
  }

  getControls() {
    return (<FormGroup>this.updateNipForm).controls;
  }

  // newProductSelected(value) {
  //   console.log('event', value);

  //   let selectedProductId = value;
  //   this.selectedProduct = this.products.data.find(
  //     (product) => product.id === selectedProductId
  //   ); // Find product with selected ID
  //   this.selectedProductOperations = this.selectedProduct.operations;
  //   this.updateNipForm.patchValue({
  //     total_estimated_time: this.selectedProduct.total_estimated_time,
  //   });

  //   console.log('selected product operation', this.selectedProductOperations);
  //   console.log('selected product ', this.selectedProduct);

  //   console.log(this.selectedProduct.total_estimated_time);
  // }

  // * Check if user come from some ADD page (NIP etc.)
  private checkIsUserFromAddPage() {
    if (this.isFromAddPage) {
      this.subscriptions.push(
        this.nipService.saveFormData.subscribe((responseData: Nip) => {
          this.savedFormData = responseData;
        })
      );
      // Patch form with saved data
      if (this.savedFormData != null) {
        this.patchFormData();
      }
    }
  }

  getReport() {
    this.subscriptions.push(
      this.nipService.getReport(this.id).subscribe({
        next: (res) => {
          this.reportData = res.data;
        },
      })
    );
  }

  createFormForUpdate() {
    this.selectedPartner = this.nipForEdit.partner.company;
    this.defaultProduct = this.nipForEdit.product?.name;

    this.updateNipForm.patchValue({
      batch: this.nipForEdit.batch,
      product_id: this.nipForEdit.product_id,
      packaging_type_id: this.nipForEdit.packaging_type_id,
      status_id: this.nipForEdit.status_id,
      required_units: this.nipForEdit.required_units,
      planned_units: this.nipForEdit.planned_units,
      note: this.nipForEdit.note,
      complaint: this.nipForEdit.complaint,
      total_estimated_time: this.nipForEdit.product.total_estimated_time,
      request_nr: this.nipForEdit.request_nr,
      partner_id: this.nipForEdit.partner_id,
      deadline: new Date(this.nipForEdit.deadline),
      parallel_operations: this.nipForEdit.parallel_operations,
      priority: this.nipForEdit.priority,
      complete: this.nipForEdit?.complete,
      enable_add_operations: this.nipForEdit.enable_add_operations,
    });
  }

  private patchFormData() {
    this.updateNipForm.patchValue({
      batch: this.nipForEdit.batch,
      product_id: this.savedFormData.product_id,
      packaging_type_id: this.savedFormData.packaging_type_id,
      status_id: this.savedFormData.status_id,
      required_units: this.savedFormData.required_units,
      planned_units: this.savedFormData.planned_units,
      note: this.savedFormData.note,
      total_estimated_time: this.savedFormData.total_estimated_time,
      request_nr: this.savedFormData.request_nr,
      partner_id: this.savedFormData.partner_id,
      deadline: this.savedFormData.deadline,
    });
    // // Update operation list
    // this.selectedProduct = this.products.data.find(
    //   (product) => product.id === this.savedFormData.product_id
    // );
    // this.selectedProductOperations = this.selectedProduct.operations;
  }

  // * Emit form when user click add partners, to save data
  goToAddPage() {
    const nip = this.updateNipForm.getRawValue();
    this.nipService.saveFormData.next(nip);
  }

  onEditTimeTracker(data) {
    this.timeTrackerId = data?.id;
    this.showModal = true;

    this.editTimeTrackerForm.patchValue({
      start: this.datePipe.transform(data?.start, 'dd.MM.yyyy HH:mm'),
      end: this.datePipe.transform(data?.end, 'dd.MM.yyyy HH:mm'),
      produced_amount: data?.produced_amount,
    });
  }

  onSaveTimeTrackerChanges() {
    const form = this.editTimeTrackerForm.getRawValue();

    this.subscriptions.push(
      this.nipService.updateTimeTracker(this.timeTrackerId, form).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešna izmena',
            detail: 'Uspešno ste izmenili.',
          });
          this.getData();
          this.showModal = false;
        },
        (error) => {
          const errorObj = error.error.errors;
          const messService = this.messService;

          // && !errorObj.ready_items

          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl && !errorObj.ready_items) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  formatStartDate() {
    const form = this.editTimeTrackerForm.getRawValue();
    this.editTimeTrackerForm
      .get('start')
      .setValue(this.datePipe.transform(form?.start, 'dd.MM.yyyy HH:mm'));
  }

  formatEndDate() {
    const form = this.editTimeTrackerForm.getRawValue();
    this.editTimeTrackerForm
      .get('end')
      .setValue(this.datePipe.transform(form?.end, 'dd.MM.yyyy HH:mm'));
  }
}
